import React from "react";

const RatesQuestionIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M7.99988 16C3.58615 16 0 12.4215 0 7.9828C0 3.54409 3.58615 0 7.99988 0C12.4136 0 15.9998 3.57849 15.9998 7.9828C16.0342 12.4215 12.4481 16 7.99988 16ZM7.99988 1.37634C4.34476 1.37634 1.37929 4.33548 1.37929 7.9828C1.37929 11.6301 4.34476 14.5892 7.99988 14.5892C11.655 14.5892 14.6205 11.6301 14.6205 7.9828C14.6549 4.33548 11.6895 1.37634 7.99988 1.37634ZM8.68952 4.12903H7.31023V9.22151H8.68952V4.12903ZM8.68952 10.4602H7.31023V11.871H8.68952V10.4602Z"
        fill="#000" />
    </svg>
  );
};

export default RatesQuestionIcon;